// useVirginSSOAuth.ts
import { useEffect, useState } from 'react'
import { NextRouter } from 'next/router'
import { LOCAL_STORAGE_KEYS } from '@/utils/constants'
import { getCurrentRefreshToken } from '@/redux/services/user'

export function useVirginSSOAuth(router: NextRouter, withRedirection = true) {
  const [isCheckingAuth, setIsCheckingAuth] = useState(true)

  useEffect(() => {
    //  Ne rien faire tant que le routeur n'est pas prêt
    if (!router.isReady) return

    const { query } = router
    const accessToken = query?.['access_token'] as string
    const tokenExpireAt = query?.['token_expires_at'] as string
    const loginMethod = query?.['login_method'] as string
    const ssoState = query?.['state'] as string

    if (accessToken) {
      saveTokensToLocalStorage({
        accessToken,
        tokenExpireAt,
        loginMethod,
        ssoState,
      })

      // Fetch and store refresh token
      getCurrentRefreshToken()
        .then((data) => {
          if (data?.refresh_token) {
            localStorage.setItem(
              LOCAL_STORAGE_KEYS.REFRESH_TOKEN,
              data.refresh_token
            )
          }
        })
        .catch((error) => {
          console.error('Failed to get refresh token:', error)
        })

      // Clean up query parameters from URL
      const cleanUrl = window.location.pathname + window.location.hash
      router.replace(cleanUrl, undefined, { shallow: true })
    } else {
      if (!withRedirection) return
      // Vérifier si on a déjà des tokens en localStorage
      try {
        const storedToken = localStorage.getItem(LOCAL_STORAGE_KEYS.TOKEN)

        if (!storedToken) {
          router.push('/register')
        }
      } catch (error) {
        router.push('/register')
      }
    }

    setIsCheckingAuth(false)
  }, [router.isReady]) // Uniquement réagir quand router.isReady change

  return { isCheckingAuth }
}

function saveTokensToLocalStorage({
  accessToken,
  tokenExpireAt,
  loginMethod,
  ssoState,
}: {
  accessToken: string
  tokenExpireAt?: string
  loginMethod?: string
  ssoState?: string
}) {
  localStorage.setItem(LOCAL_STORAGE_KEYS.TOKEN, accessToken)
  if (tokenExpireAt) {
    localStorage.setItem(LOCAL_STORAGE_KEYS.TOKEN_EXPIRE_AT, tokenExpireAt)
  }
  localStorage.setItem(
    LOCAL_STORAGE_KEYS.CONNEXION_TYPE,
    process.env.SSO_TYPE || ''
  )
  localStorage.setItem(LOCAL_STORAGE_KEYS.LOGIN_METHOD, loginMethod || '')
  localStorage.setItem(LOCAL_STORAGE_KEYS.SSO_STATE, ssoState || '')
  localStorage.setItem(LOCAL_STORAGE_KEYS.USER_TYPE, 'SSO')
}
